/**
 * Created by vtbelo on 28.02.18.
 */
const BaseCellComponent = function (view, cell) {
    view.setPosition(EditorView.alignInTheGrid(cell.x, cell.y));
    view.setLocalZOrder(3);
    cell.currentView = view;
    this.field.addChild(view);
};

const BigCellComponent = function (view, cell) {
    view.setPosition(EditorView.alignInTheGrid(cell.x + 0.5, cell.y + 0.5));
};

const BlanketCellComponent = function (view, cell, saveCallback) {
    const bigComponent = cell.findComponent(BigComponent);
    view.setPosition(EditorView.alignInTheGrid(cell.x + bigComponent.cols / 2 - 0.5, cell.y + bigComponent.rows / 2 - 0.5));
    
    let styles = cleverapps.styles.EditorView.blanketCell.sizeButton;
    const sizeButton = new cleverapps.UI.Button({
        type: cleverapps.styles.UI.Button.Images.editor,
        text: "sz",
        width: styles.width,
        height: styles.height,
        onClicked: function () {
            const editor = cleverapps.Scenes.GetRunningScene().editor;
            let sizesCorrect = false;
            const rows = parseInt(window.prompt("Number of rows:"));
            if (!isNaN(rows)) {
                const cols = parseInt(window.prompt("Number of columns:"));
                if (!isNaN(cols)) {
                    if (rows >= 2 && rows <= editor.cells.length && cols >= 2 && cols <= editor.cells[0].length) {
                        sizesCorrect = true;
    
                        editor.clearBlanketCell(cell);
                        
                        const newCell = new BlanketCell(cell.x, cell.y, rows, cols);
                        newCell.setAcceptedColors(cell.getAcceptedColors());
                        newCell.lives = cell.lives;
                        
                        if (editor.cellCanBeSetUp(newCell.x, newCell.y, newCell)) {
                            if (editor.cells[newCell.y][newCell.x]) {
                                newCell.setInnerCell(editor.cells[newCell.y][newCell.x]);
                            } else {
                                newCell.setInnerCell(new EditorRandomCell(newCell.x, newCell.y));
                            }

                            editor.changeCell(newCell);
                            editor.changeBlanketCell(newCell);
                            cell = newCell;
                        } else {
                            editor.changeCell(cell); // return back old cell
                            editor.changeBlanketCell(cell);
                            console.log("BLANKET CELLS CAN'T BE PLACED THERE WITH SIZE ", rows, " x ", cols);
                        }
                        
                        saveCallback();
                    }
                }
            }
            if (!sizesCorrect) {
                console.log("INCORRECT SIZES (must be not less than 2 and not more than field size)");
            }
        }
    });
    view.addChild(sizeButton);
    sizeButton.setAlignment(view.width - styles.width / 2, styles.height / 2);
    
    styles = cleverapps.styles.EditorView.blanketCell.colorButton;
    const colorButton = new cleverapps.UI.Button({
        type: cleverapps.styles.UI.Button.Images.editor,
        text: "c",
        width: styles.width,
        height: styles.height,
        onClicked: function () {
            if (view.colorChooseWindow) {
                view.colorChooseWindow.removeFromParent(true);
                view.colorChooseWindow = undefined;
                return;
            }
            const editor = cleverapps.Scenes.GetRunningScene().editor;
            const node = view.colorChooseWindow = new cc.Node();
            node.setAnchorPoint(0.5, 0.5);
            const bg = new cc.Scale9Sprite(bundles.request_center.frames.friend_message_bg_png);
            node.addChild(bg);
            node.setLocalZOrder(11);
    
            const colors = ["a", "b", "c", "d", "e", "w"];
            let height;
            colors.forEach((color) => {
                const button = new cleverapps.UI.Button({
                    width: cleverapps.styles.EditorView.blanketCell.colorItem.width,
                    height: cleverapps.styles.EditorView.blanketCell.colorItem.height,
                    onClicked: function () {
                        cell.setAcceptedColors([color]);
                        editor.onDeleteCell(editor.cells[cell.y][cell.x]);
                        editor.onCellChanged(cell);
                        saveCallback();
    
                        view.colorChooseWindow.removeFromParent(true);
                        view.colorChooseWindow = undefined;
                    },
                    content: new cc.Sprite(bundles.color_cells.frames[`color_cells_${color}`])
                });
        
                height = button.height;
                button.setPosition(bg.width / 2, 0);
                bg.addChild(button);
            });
    
            bg.setContentSize2(bg.width, height * colors.length + (colors.length - 1) * cleverapps.styles.EditorView.blanketCell.colorItem.margin);
            node.setContentSize2(bg.getContentSize());
            bg.setAlignment(node.width / 2, node.height / 2);
    
            cleverapps.UI.arrangeWithMargins(bg.children, {
                direction: cleverapps.UI.VERTICAL,
                margin: cleverapps.styles.EditorView.blanketCell.colorItem.margin
            });
    
            cleverapps.Scenes.GetRunningScene().addChild(node);
            const p = EditorView.alignInTheGrid(cell.x, cell.y);
            p.x += cleverapps.styles.BaseCellView.CELL_SIZE_PX * (bigComponent.cols - 1) / 2;
            p.y -= cleverapps.styles.BaseCellView.CELL_SIZE_PX * (bigComponent.rows - 1) / 2;
            p.x += view.width / 2 + node.width / 2 + cleverapps.styles.BaseCellView.CELL_SIZE_PX / 4;
            const globalViewPos = view.getParent().convertToWorldSpace(p);
            node.setAlignment(globalViewPos.x, globalViewPos.y);
        }
    });
    view.addChild(colorButton);
    colorButton.setAlignment(styles.width / 2, styles.height / 2);
};

const changeLives = function (view, cell, lives) {
    const min = cell.getMinLives ? cell.getMinLives() : 1;
    let max = Number.MAX_VALUE;

    const muffinComponent = cell.findComponent(MuffinComponent);
    if (cell.getMaxLives) {
        max = cell.getMaxLives();
    } else if (muffinComponent) {
        max = muffinComponent.getMaxLives();
    }

    if (lives >= min && lives <= max) {
        cell.lives = lives;

        const liveLineComponent = cell.findComponent(LiveLineComponent);
        if (view.changeLives) {
            view.changeLives(true);
        } else if (liveLineComponent) {
            liveLineComponent.view.changeLives(true);
        }

        this.needSave();
    }
};

const SpecialShapeCellComponent = function (view, cell) {
    const size = cell.findComponent(SpecialShapeComponent).getSize();
    view.setPosition(EditorView.alignInTheGrid(cell.topLeftX + size.cols / 2 - 0.5, cell.topLeftY + size.rows / 2 - 0.5));

    const styles = cleverapps.styles.EditorView.specialShapeCell.rotationButton;

    const button = new cleverapps.UI.Button({
        type: cleverapps.styles.UI.Button.Images.editor,
        text: "r",
        width: styles.width,
        height: styles.height,
        onClicked: function () {
            const editor = cleverapps.Scenes.GetRunningScene().editor;
            editor.deleteSpecialShapeCell(cell);
            cell.rotation = (cell.rotation + 1) % 4;
            const saveData = cell.findComponent(SpecialShapeComponent).getSaveData().join("");
            editor.clickField(cell.topLeftX, cell.topLeftY, saveData, "goal_cell");
            this.needSave();
        }.bind(this)
    });

    view.addChild(button);
    button.setAlignment(view.width / 2 + styles.x, view.height / 2 + styles.y);
};

const MovesCellComponent = function (view, cell) {
    const incDecBlock = new IncDecBlock({
        value: cell.moves,
        range: [1, Infinity],
        onChange: function (value) {
            cell.moves = value;
            view.updateMoves();
            this.needSave();
        }.bind(this),
        radius: cleverapps.styles.EditorView.colorBombCell.radius.width
    });
    incDecBlock.setPosition(view.width / 2, cleverapps.styles.EditorView.colorBombCell.y);
    view.addChild(incDecBlock);
};

const CannonCellComponent = function (view, cell) {
    const styles = cleverapps.styles.EditorView.cannonCell;
    let window;
    const loader = new Loader();

    const itemsByDir = {};

    const selectCurrDir = function (dir) {
        const currItem = itemsByDir[cell.currDir];
        if (currItem && currItem.dirView.currDirCheck) {
            currItem.dirView.currDirCheck.removeFromParent(true);
            delete currItem.dirView.currDirCheck;
        }

        cell.currDir = dir;

        const currDirCheck = new cc.Sprite(bundles.checkbox.frames.check_mark_png);
        itemsByDir[dir].dirView.addChild(currDirCheck);
        itemsByDir[dir].dirView.currDirCheck = currDirCheck;
        currDirCheck.setAlignment(styles.currDirCheckBox.x, view.height + styles.currDirCheckBox.y);
    
        view.angle = CannonCellView.ROTATION_BY_DIR[dir];
        view.animationsNode.setRotation(-view.angle);
        
        setSelected(dir);
    };

    const setSelected = function (dir) {
        if (cell.dirs.indexOf(dir) !== -1) {
            return;
        }

        cell.dirs.push(dir);
        cell.dirs.sort();
        itemsByDir[dir].checkBox.setSelected(true);
    };

    const createContent = function () {
        const dirs = Object.keys(BaseCell.DIRECTIONS).map((key) => parseInt(key));
        const amountInRow = 4;
        const rows = [];
        while (dirs.length > 0) {
            const itemsInRow = [];
            dirs.splice(0, amountInRow).forEach((dir) => {
                const checkBox = new cleverapps.UI.CheckBox({
                    onChange: function (state) {
                        if (state) {
                            setSelected(dir);
                        } else {
                            if (cell.dirs.length === 1) {
                                checkBox.setSelected(true);
                                return;
                            }

                            const index = cell.dirs.indexOf(dir);
                            if (index !== -1) {
                                cell.dirs.splice(index, 1);
                            }

                            if (dir === cell.currDir) {
                                selectCurrDir(cell.dirs[0]);
                            }
                        }
                        this.needSave();
                    }.bind(this),
                    isSelected: cell.dirs.indexOf(dir) !== -1
                });

                const code = (`m3${dir}1${1 << dir}`).split("");
                const dirCell = loader.loadNext(this.y, this.x, code);
                const dirView = new (dirCell.getViewClass())(dirCell);
                dirView.setLocalZOrder(10);
                dirView.setPosition(0, 0);

                cleverapps.UI.onClick(dirView, () => {
                    if (dir === cell.currDir) {
                        return;
                    }

                    selectCurrDir(dir);
                    this.needSave();
                });

                const item = new cleverapps.Layout([dirView, checkBox], {
                    direction: cleverapps.UI.VERTICAL,
                    margin: styles.itemsMargin
                });

                itemsByDir[dir] = {
                    checkBox,
                    dirView
                };

                if (dir === cell.currDir) {
                    selectCurrDir(dir);
                }

                itemsInRow.push(item);
            });

            const row = new cleverapps.Layout(itemsInRow, {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.rowsMargin
            });

            rows.push(row);
        }

        const dirsLayout = new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.rowsMargin
        });

        const clockwiseCheckBox = new cleverapps.UI.CheckBox({
            onChange: function (state) {
                cell.clockwise = state;
                this.needSave();
            }.bind(this),
            label: {
                text: "Clockwise"
            },
            isSelected: cell.clockwise
        });

        const layout = new cleverapps.Layout([dirsLayout, clockwiseCheckBox], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.clockwiseCheckBoxMargin
        });

        return layout;
    }.bind(this);

    const button = new cleverapps.UI.Button({
        type: cleverapps.styles.UI.Button.Images.editor,
        text: "r",
        width: styles.dirButton.width,
        height: styles.dirButton.height,
        onClicked: function () {
            if (window) {
                window.close();
                window = undefined;
                return;
            }
            window = EditorWindow.create(createContent(), cell, view, {
                onClose: function () {
                    window = undefined;
                }
            });
        }
    });

    view.addChild(button);
    button.setAlignment(view.width / 2 + styles.dirButton.x, view.height / 2 + styles.dirButton.y);
};

const ChangeLivesOnClickComponent = function (view, cell, cb) {
    cell.changeLivesOnClick = function () {
        const lives = parseInt(window.prompt("Lives", cell.lives));
        if (!isNaN(lives)) {
            cb(view, cell, lives);
        }
    };
};

const LiveLineEditorComponent = function (view, cell) {
    const incDecBlock = new IncDecBlock({
        value: cell.lives,
        range: [1, Infinity],
        onChange: function (value) {
            changeLives.call(this, view, cell, value);
        }.bind(this)
    });
    ChangeLivesOnClickComponent.call(this, view, cell, (view, cell, lives) => {
        changeLives.call(this, view, cell, lives);
        incDecBlock._setValue(lives, true);
    });
    const x = view.width / 2;
    const y = view.height / 2;
    if (view instanceof FigureDragonCellView) {
        view.lives.setVisible(false);
    }
    incDecBlock.setAlignment(x, y);
    view.addChild(incDecBlock);
};

const FireflyJarComponent = function (view, cell) {
    let livesText;
    const incDecBlock = new IncDecBlock({
        value: cell.lives,
        range: [1, cell.getMaxLives ? cell.getMaxLives() : Number.MAX_VALUE],
        onChange: function (value) {
            changeLives.call(this, view, cell, value);
            livesText.setString(value);
        }.bind(this),

        radius: cleverapps.styles.EditorView.fireflyJarCell.radius.width
    });

    incDecBlock.setPosition(view.width / 2, cleverapps.styles.EditorView.fireflyJarCell.y);
    view.addChild(incDecBlock);

    livesText = cleverapps.UI.generateImageText(cell.lives, cleverapps.styles.FONTS.EDITOR_BLACK_TEXT);
    view.addChild(livesText);
    livesText.setAlignment(view.width / 2, view.height / 2);

    ChangeLivesOnClickComponent.call(this, view, cell, (view, cell, lives) => {
        changeLives.call(this, view, cell, lives);
        incDecBlock._setValue(lives, true);
        livesText.setString(cell.lives);
    });
};

const BlanketCellComponentCreator = function (view, cell) {
    new BlanketCellComponent(view, cell, this.needSave.bind(this));
};

const MultiColorBombCellComponentCreator = function (view, cell) {
    new MultiColorBombCellComponent(view, cell, this.needSave.bind(this));
};

const ClockCellComponentCreator = function (view, cell) {
    new ClockCellComponent(view, cell, this.needSave.bind(this));
};

const ColorBombCellComponent = function (view, cell) {
    const incDecBlock = new IncDecBlock({
        value: cell.lives,
        range: [1, cell.getMaxLives ? cell.getMaxLives() : Number.MAX_VALUE],
        onChange: function (value) {
            changeLives.call(this, view, cell, value);
        }.bind(this),

        radius: cleverapps.styles.EditorView.colorBombCell.radius.width
    });
    ChangeLivesOnClickComponent.call(this, view, cell, (view, cell, lives) => {
        changeLives.call(this, view, cell, lives);
        incDecBlock._setValue(lives, true);
    });

    incDecBlock.setPosition(view.width / 2, cleverapps.styles.EditorView.colorBombCell.y);
    view.addChild(incDecBlock);
};

const BombCellComponent = function (view, cell) {
    const changeUntilExplode = function (view, cell, basicUntilExplode) {
        if (basicUntilExplode >= 1) {
            cell.basicUntilExplode = basicUntilExplode;
            cell.untilExplode = cell.basicUntilExplode;
            view.onUntilExplodeChanged();
            this.needSave();
        }
    }.bind(this);

    const incDecBlock = new IncDecBlock({
        value: cell.basicUntilExplode,
        range: [1, Infinity],
        onChange: function (value) {
            changeUntilExplode(view, cell, value);
        },
        radius: cleverapps.styles.EditorView.bombCell.radius.width
    });

    ChangeLivesOnClickComponent.call(this, view, cell, (view, cell, lives) => {
        changeUntilExplode(view, cell, lives);
        incDecBlock._setValue(lives, true);
    });

    incDecBlock.setPosition(view.width / 2, cleverapps.styles.EditorView.bombCell.y);
    view.addChild(incDecBlock);
};

const SwitchModeComponent = function (view, cell) {
    const styles = cleverapps.styles.EditorView.switchMode;

    const createType = cleverapps.UI.generateOnlyText("SIMPLE", cleverapps.styles.FONTS.EDITOR_FIELD_TEXT);
    createType.setDimensions(styles.width, 0);
    createType.fitTo(undefined, styles.height);
    createType.setAnchorPoint(0, 0.5);
    const drawCreateType = function () {
        createType.setString(cell.createType === CreateTypes.NOT_CREATE_AGAIN_TYPE ? "SIMPLE" : "AUTO");
    };
    drawCreateType();
    createType.setPosition(0, view.height - createType.height / 2);
    view.addChild(createType);

    cleverapps.UI.onClick(createType, () => {
        if (cell.createType === CreateTypes.NOT_CREATE_AGAIN_TYPE) {
            cell.createType = CreateTypes.CREATE_AGAIN_TYPE;
        } else {
            cell.createType = CreateTypes.NOT_CREATE_AGAIN_TYPE;
        }
        drawCreateType();
        this.needSave();
    });

    cleverapps.UI.applyHover(createType);
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    EDITOR_FIELD_TEXT: {
        size: 20,
        color: cleverapps.styles.COLORS.BLACK
    }
});